import { Card, Collapse, Flex, Tag, Typography } from 'antd';
import { useQueryClient } from '@tanstack/react-query';
import { useGetRuleGroups, ruleGroupsQueryKeys } from '@/features/agreements/hooks/useRuleGroups';
import { RateActionsDropdown } from './RateActionsDropdown';
import { LoadingIndicator } from '@/shared/components/LoadingIndicator';
import { ErrorMessage } from '@/shared/components/ErrorMessage';
import { RuleGroupCard } from '../RuleGroupCard';

const { Text } = Typography;

export const RateCard = ({ rate, agreementId, planId, getOperatorLabel, getOperatorDescription, onEdit, readOnly = false }) => {
  const queryClient = useQueryClient();
  const ruleGroupsQuery = useGetRuleGroups(
    { rateId: rate.id },
    { enabled: !!rate.id }
  );

  const ruleGroups = (ruleGroupsQuery.data ?? []).filter((ruleGroup) => ruleGroup.active); // Solo se muestra el grupo de reglas principal activo
  const hasRuleGroups = ruleGroups.length > 0;
  const isActive = rate.active !== false;

  return (
    <Card
      size='small'
      style={{
        marginTop: -1,
        borderColor: '#d9d9d9',
        backgroundColor: 'transparent',
      }}
      styles={{
        body: { paddingInline: '3%' },
      }}
    >
      <Flex justify='space-between' align='flex-start' gap='small'>
        <Flex vertical gap='small' flex={1}>
          <Flex align='center' gap='small'>
            <Text strong style={{ fontSize: '1.1em' }}>
              Tasa {rate.percentage}%
            </Text>
            <Tag color={isActive ? 'green' : 'red'}>
              {isActive ? 'Activa' : 'Inactiva'}
            </Tag>
          </Flex>

          {ruleGroupsQuery.isLoading ? (
            <LoadingIndicator />
          ) : ruleGroupsQuery.isError ? (
            <ErrorMessage error={ruleGroupsQuery.error} />
          ) : hasRuleGroups ? (
            <Collapse
              ghost
              items={[
                {
                  key: 'rules',
                  label: <Text type='secondary'>Ver condiciones</Text>,
                  children: (
                    <Flex vertical gap='middle'>
                      {ruleGroups.map((ruleGroup) => (
                        <RuleGroupCard
                          key={ruleGroup.id}
                          ruleGroup={ruleGroup}
                          level={0}
                          parentActive={true}
                          getOperatorLabel={getOperatorLabel}
                          getOperatorDescription={getOperatorDescription}
                          onChange={() => {
                            void queryClient.invalidateQueries({
                              queryKey: ruleGroupsQueryKeys.list({ rateId: rate.id }),
                            });
                          }}
                          showRuleActions={!readOnly}
                          showGroupActions={!readOnly}
                        />
                      ))}
                    </Flex>
                  ),
                  styles: {
                    header: { padding: 0 },
                  },
                },
              ]}
            />
          ) : (
            <Text type='secondary' italic style={{ fontSize: '0.9em' }}>
              No hay reglas creadas
            </Text>
          )}
        </Flex>

        {!readOnly && (
          <RateActionsDropdown
            rate={rate}
            agreementId={agreementId}
            planId={planId}
            onEdit={onEdit}
          />
        )}
      </Flex>
    </Card>
  );
};
